import {
  Component,
  OnInit,
  HostListener,
  Output,
  EventEmitter,
} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { MatDialog } from '@angular/material/dialog';
import { Subject, Subscription } from 'rxjs';
import { ApiService } from '../common/services/api.service';
import { EventTrackerService } from '../common/services/event-tracker.service';
import { UtilService } from '../util/util.service';
import { Event as EventList } from 'src/app/pusher-event';
import { PusherEventService } from '../common/services/pusher-event.service';
import { takeUntil } from 'rxjs/operators';
import { ASPECT_RATIO_MATERIAL, TIMER, CASH_TABLE_SERVICE } from 'src/defaultImages.js';
import { OrderTypeEnum } from '../common/enums/order.enum';

@Component({
  selector: 'app-payment-request',
  templateUrl: './payment-request.component.html',
  styleUrls: ['./payment-request.component.css'],
})
export class PaymentRequestComponent implements OnInit {
  images = { 
    ASPECT_RATIO_MATERIAL: ASPECT_RATIO_MATERIAL,
    TIMER: TIMER,
    CASH_TABLE_SERVICE: CASH_TABLE_SERVICE
  };
  token: string;
  restaurantId: string;
  currentOrderId: string;
  currentOrderNo: string;
  private subscription: Subscription[] = [];

  allNotification: {
    table_no: string;
    floor_name: string;
    username: string;
    message: string;
    msg_text: string;
    message_id: string;
    order_id: string;
    order_ids: any;
    collect_cash: boolean;
    time_stamp: number;
    time_text: string;
  }[] = [];
  modalWidth: string;
  noItems: boolean = false;
  private ngUnsubscribe = new Subject();

  constructor(
    private http: HttpClient,
    private apiService: ApiService,
    public dialog: MatDialog,
    public utilService: UtilService,
    private _pusherEvent: PusherEventService,
    private _eventTracker: EventTrackerService
  ) {}

  @Output() notify: EventEmitter<any> = new EventEmitter();
  @HostListener('window:resize', ['$event'])
  onResize(event?) {
    let innerWidth = window.innerWidth;
    if (innerWidth < 768) {
      // this.modalPosition = {left : '0%',top : '0%'};
      this.modalWidth = '100vw !important';
    } else {
      // this.modalPosition = {left : '35%',top : '5%'};
      this.modalWidth = '80vw !important';
    }
  }

  ngOnInit() {
    this.token = localStorage.getItem('token');
    this.restaurantId = localStorage.getItem('restaurant_id');
    this.get_notification();
    this.watchPusherEvents();
  }
  ngOnDestroy(): void {
    // this.unsubscribe_from_all_topic();
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  watchPusherEvents() {
    /*Watching table events on pusher*/

    this._pusherEvent
      .watchEvent(EventList.TABLE_EVENT)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((event) => this.new_message_mqtt(JSON.stringify(event)));
  }
  // subscribe_to_mqtt_topic(topic) {
  //   try {
  //     this.subscription.push(
  //       this.mqttService
  //         .observe(topic)
  //         .subscribe((message: IMqttMessage) =>
  //           this.new_message_mqtt(message.payload.toString())
  //         )
  //     );
  //   } catch (error) {
  //   }
  // }

  unsubscribe_from_all_topic() {
    try {
      this.subscription.forEach((element) => {
        element.unsubscribe();
      });
    } catch (error) {}
  }

  new_message_mqtt(message) {
    message = JSON.parse(message);

    // this.update_activenav(this.activeNav);
    if (message.mtype === 'CSH' || message.data?.service_type === 'collect cash') {
      this.get_notification();
    }
  }

  // subscribeToAllTables(data) {
  //   try {
  //     data["data"]["tables"].forEach((tableid) => {
  //       this.subscribe_to_mqtt_topic(
  //         localStorage.getItem("restaurant_id") + "_" + tableid
  //       );
  //     });
  //   } catch (error) {
  //   }
  // }

  get_notification() {
    const formData: any = new FormData();
    formData.append('token', this.token);

    // [PHP_TO_NEST_ROLLOUT] routed through ApiService so migration switch applies centrally
    this.apiService
      .getTableNotifications(formData)
      .subscribe((data: any) => {
        this.populate_notification(data);
      },
      (error) => {
        console.error("Error while fetching notifications count", error?.message);
      }
    );
  }

  async openModal(item) {
    let mid = item.message_id;
    let oid = item.order_id;
    let oids = item.order_ids;
    let floor_name = item.floor_name;
    let timestamp = Number(item.time_stamp);
    let timeinsec = Math.floor(Date.now() / 1000) - timestamp;
    this._eventTracker.easyeat_track_event('PAYMENT_REQUEST_VIEWED', {
      TABLE_NO: item.table_no,
      REQUEST_TAB: 'PAYMENT REQUEST',
      TABLE_FLOOR: floor_name,
      TIME_TAKEN_TO_SERVICE: Number(timeinsec),
      SERVICE_REQUESTED: item.msg_text,
    });
    const { OrderDetailsComponent } = await import(
      /* webpackPrefetch: true */ '../server/components/order-details/order-details.component'
    );
    const dialogRef = this.dialog.open(OrderDetailsComponent, {
      backdropClass: 'custom-dialog-backdrop-class',
      panelClass: 'custom-dialog-panel-class',
      data: {
        order_id: oid,
        order_ids: oids,
        mid,
        showQris: true,
        showDuitnow: true,
      },
      maxWidth: this.modalWidth,
      maxHeight: '90vh',
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (!result) return;
      if (result.ack) {
        this.ack_notification(mid);
      }
    });
  }

  ack_notification(messageid) {
    const formData: any = new FormData();
    formData.append('token', this.token);
    formData.append('message_id', messageid);
    // [PHP_TO_NEST_ROLLOUT] routed through ApiService so migration switch applies centrally
    this.apiService
      .acknowelgeTableNotification(formData)
      .subscribe((data: any) => {
        this.get_notification();
        this.notify.emit('refresh');
      });
  }

  populate_notification(notifications) {
    this.allNotification = [];
    this.noItems = true;
    if (notifications['status'] === 1) {
      for (const notification of notifications['data']) {
        if (notification['ack'] === 0) {
          let cc = (notification['data']['service_type'] == 'collect cash' || notification['data']['msg_text'] == 'Collect Cash');
          if (cc) {
            this.allNotification.push({
              username: notification['sender_name'],
              floor_name: notification['data']['floor_name'],
              table_no: (notification['data']['table_no'] || '').toLowerCase() === OrderTypeEnum.PICKUP ? 'PU' : notification['data']['table_no'],
              message: notification['data']['service_type'],
              msg_text: notification['data']['msg_text'],
              message_id: notification['mid'],
              order_id: notification['data']['order_id'],
              order_ids: notification['data']['order_ids'],
              collect_cash: cc,
              time_stamp: parseInt(notification['time_stamp']),
              time_text: notification['time_text'],
            });
            this.noItems = false;
          }

          // if(cc){
          //   this.sliderValue[notification["data"]["order_id"]] = 50;
          // }
        }
      }

      this.allNotification.sort((a, b) => b.time_stamp - a.time_stamp);
    }
  }

  payment_status_in_str(paymentstatus: string) {
    if (paymentstatus === '1') {
      return 'Not paid';
    } else if (paymentstatus === '2') {
      return 'Partially paid';
    } else if (paymentstatus === '3') {
      return 'Paid';
    } else if (paymentstatus === '4') {
      return 'Paid';
    }
  }
  order_since_in_str(orderedsince: number) {
    if (orderedsince < 3600) {
      if (orderedsince < 60) {
        return 'a min';
      }
      return Math.floor(orderedsince / 60) + ' mins';
    } else {
      if (orderedsince < 3600 * 24) {
        if (orderedsince / 3600 == 1) {
          return '1 hour';
        }
        return Math.floor(orderedsince / 3600) + ' hours';
      } else {
        if (orderedsince / (3600 * 24) == 1) {
          return '1 day';
        }
        return Math.floor(orderedsince / (3600 * 24)) + ' days';
      }
    }
  }
}
